import { Card } from '@innovationnorway/component-library';
import React from 'react';

type Props = {
  customerName: string;
  note: string;
  opportunityTitle: string;
  receivingActors: string;
  fromActorName: string;
  handlerName?: string;
};

const ReferralMailCustomer: React.FC<Props> = ({
  customerName,
  note,
  opportunityTitle,
  receivingActors,
  fromActorName,
  handlerName,
}) => {
  return (
    <Card className="email-preview padding--2 stack-medium font-size--medium">
      <p>
        {customerName}, din henvendelse: <em>{opportunityTitle}</em>, er henvist til {receivingActors}.
      </p>
      <p>Melding fra {fromActorName}:</p>
      <p className="white-space--pre-wrap">{note}</p>
      {handlerName && <p>Med vennlig hilsen {handlerName}</p>}
      <p>MERK: Svar til denne e-postadressen blir ikke behandlet.</p>
    </Card>
  );
};

export default ReferralMailCustomer;
